const requestsAnalysis = {
  icon: 'PieChartIcon',
  title: 'Requests Analysis',
  subtitle: 'Live numbers across all sources.',
  goto: 'analysis',
  gotoLabel: 'Back to Analysis',
  gotoIcon: 'ArrowLeftIcon',
}

export default requestsAnalysis
